module.exports = __webpack_public_path__ + "static/img/C (1).9311d94f.png";